<template>
    <div>
        自分の情報
    </div>
</template>

<script>
export default {
    name: 'Intro'
}
</script>



// WEBPACK FOOTER //
// src/pages/Intro.vue